import React from "react";
import HallImgCarousel from "../HallImgCarousel";
import "./hallDetailCard.scss";

type Props = {
    type: "waitingRoom" | "banquetHall"; // 신부대기실(waitingRoom), 연회장(banquetHall) 구분
    title: string;
    imgs: { url: string; title: string }[];
    howToEnter?: string[];
    toilet?: boolean;
    meals?: {
        type: "BUFFET" | "COURSE" | "ONE_TABLE" | "ONE_TABLE_WITH_SEMI_BUFFET";
        ceremonyType: "SAME_TIME" | "SEPARATION";
    }[];
    useTime?: number;
    capacity?: number;
};
const getBrideRoomEntranceMethodStr = (virginRoadHeight: string) => {
    let value = "";
    switch (virginRoadHeight) {
        case "DIRECT":
            value = "신부대기실에서 바로 입장";
            break;
        case "VIA_STAIRS":
            value = "계단을 통해 입장";
            break;
        case "VIA_HIDDEN_SPACE":
            value = "히든공간을 통해 입장";
            break;
        case "VIA_LIFT":
            value = "리프트를 통해 입장";
            break;
        case "FROM_FRONT":
            value = "정면에서 입장";
            break;
        case "FROM_LOBBY":
            value = "로비에서 입장";
            break;
        case "L_SHAPE":
            value = "ㄱ자 입장";
            break;
        case "U_SHAPE":
            value = "ㄴ자 입장";
            break;
        case "Z_SHAPE":
            value = "ㄷ자 입장";
            break;
        case "ETC":
            value = "기타";
            break;
    }
    return value;
};
const getBanquetHallMealTypeStr = (virginRoadHeight: string) => {
    let value = "";
    switch (virginRoadHeight) {
        case "BUFFET":
            value = "뷔페";
            break;
        case "COURSE":
            value = "코스";
            break;
        case "ONE_TABLE":
            value = "한상차림";
            break;
        case "ONE_TABLE_WITH_SEMI_BUFFET":
            value = "한상차림+세미뷔페";
            break;
    }
    return value;
};
const getBanquetHallMealCeremonyTypeStr = (virginRoadHeight: string) => {
    let value = "";
    switch (virginRoadHeight) {
        case "SAME_TIME":
            value = "동시예식";
            break;
        case "SEPARATION":
            value = "분리예식";
            break;
        case "ONE_TABLE":
            value = "한상차림";
            break;
    }
    return value;
};

export default function HallDetailCard({
    type,
    title,
    imgs,
    howToEnter = [],
    toilet = false,
    meals,
    useTime = 0,
    capacity = 0,
}: Props) {
    return (
        <div>
            <HallImgCarousel type="hallDetail" height={281} imgs={imgs} />
            <ul className="info-wrap">
                <h2>{title}</h2>
                {/* 신부대기실 */}
                {type === "waitingRoom" && (
                    <>
                        <li className="title-content-wrap">
                            <p className="title">입장방법</p>
                            <div>
                                {howToEnter.map((how, i) => (
                                    <p key={i}>{getBrideRoomEntranceMethodStr(how)}</p>
                                ))}
                            </div>
                        </li>
                        <li className="title-content-wrap">
                            <p className="title">화장실</p>
                            <p>{toilet ? "있음" : "없음"}</p>
                        </li>
                    </>
                )}
                {/* 연회장 */}
                {type === "banquetHall" && (
                    <>
                        <li className="title-content-wrap">
                            <p className="title">식사종류</p>
                            <p>
                                {meals.map(({ type }, i) => (
                                    <span key={i}>
                                        {getBanquetHallMealTypeStr(type)}
                                        {meals.length - 1 === i ? "" : ", "}
                                    </span>
                                ))}
                            </p>
                        </li>
                        <li className="title-content-wrap">
                            <p className="title">예식형태</p>
                            <p>
                                {meals.map(({ ceremonyType }, i) => (
                                    <span key={i}>
                                        {getBanquetHallMealCeremonyTypeStr(ceremonyType)}
                                        {meals.length - 1 === i ? "" : ", "}
                                    </span>
                                ))}
                            </p>
                        </li>
                        <li className="title-content-wrap">
                            <p className="title">이용시간</p>
                            <p>{useTime}분</p>
                        </li>
                        <li className="title-content-wrap">
                            <p className="title">수용인원</p>
                            <p>{capacity}명</p>
                        </li>
                    </>
                )}
            </ul>
        </div>
    );
}
